// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreatePayPalSetting_createButton__3-vcA","buttonsContainer":"CreatePayPalSetting_buttonsContainer__1WRvX"};